'use client'
import { useTranslation } from 'react-i18next'
import React, { useMemo, useState } from 'react'
import Cookies from 'js-cookie'
import Link from 'next/link'
import AccountSetting from '../header/account-setting'
import {
  Topbar,
  login,
  setScopeInCookie,
  setTenantInCookie,
  useUserInfo,
} from '@/fe-common'
import type { IProject, ProjectScopeType } from '@/fe-common'
import { useSiteContext } from '@/context/site-context'
import { useConfigContext } from '@/context/config-context'
import { isLTC } from '@/config'
import { useCustomWebsiteTitle } from '@/fe-common/components/Topbar/hooks'

type IProps = {
  children?: React.ReactNode
  onMenuClicked?: () => void
}

export default function Header(props: IProps) {
  const { children, onMenuClicked } = props
  const [userInfo] = useUserInfo()
  const projectList = useMemo(() => userInfo?.projects ?? null, [userInfo])
  const [settingVisible, setSettingVisible] = useState(false)
  const currentProject: IProject | null = useMemo(
    () => projectList?.find(i => i.id === userInfo?.projectId) ?? null,
    [projectList, userInfo?.projectId],
  )
  const { t } = useTranslation()
  const site = useSiteContext()
  const config = useConfigContext()
  const currentScope = Cookies.get('scope')
  const showSettings = !isLTC || config.appbuilder.enabled

  const handleProjectChange = async (p: IProject, scope: ProjectScopeType) => {
    if (p.id === currentProject?.id && scope === currentScope) {
      return
    }
    setScopeInCookie(scope)
    setTenantInCookie(p.id)
    await login({ tenantId: p.id })
    window.location.reload()
  }

  const remoteTitle = useCustomWebsiteTitle()
  const title = useMemo(() => remoteTitle || site.name, [remoteTitle, site])

  return (
    <Topbar
      currentProject={currentProject ?? projectList?.[0]}
      projectList={projectList}
      userInfo={userInfo}
      onProjectChange={handleProjectChange}
      onMenuClicked={onMenuClicked}
      projectScope={currentScope as ProjectScopeType}
      title={title}>
      <div className='flex justify-end items-center ml-auto text-sm'>
        <div className='flex space-x-4'>
          {/* <div className=''>支持</div>
          <div className=''>文档</div> */}
          <Link href='/bill/account-overview' target='_blank'>
            {t('billing.menu.fee')}
          </Link>
          {showSettings && (
            <>
              <div className='' onClick={() => setSettingVisible(true)}>
                <div>{t('common.userProfile.settings')}</div>
              </div>
              {settingVisible && (
                <AccountSetting onCancel={() => setSettingVisible(false)} />
              )}
            </>
          )}
          {children}
        </div>
      </div>
    </Topbar>
  )
}
